<script setup lang="ts">
defineProps<{
  title?: string
  description?: string
  cancelLabel?: string
  confirmLabel?: string
  confirmColor?: any
}>();

defineEmits(["confirm", "cancel"]);
</script>

<template>
  <UModal :title="title" :description="description" :ui="{title:'text-h4'}">
    <template #footer>
      <div class="flex w-full gap-2 justify-between">
        <UButton
            color="neutral"
            variant="outline"
            size="sm"
            :label="cancelLabel || 'Annuler'"
            @click="$emit('cancel')"
        />
        <UButton
            :color="confirmColor || 'primary'"
            variant="solid"
            size="sm"
            :label="confirmLabel || 'Confirmer'"
            @click="$emit('confirm')"
        />
      </div>
    </template>
  </UModal>
</template>
